// 静态资源地址前缀
let staticUrl = 'static/images/' ;
// 网络资源地址前缀
let httpUrl = 'https://buchtech-1301015442.cos.ap-guangzhou.myqcloud.com/';

let resources = {
  //首页
  index:{
    // 发展历程的背景图(尺寸:500*500)
    history: staticUrl + 'history/001.jpg',
    //企业动态的背景图(尺寸:740*500)
    cases: staticUrl + 'history/002.jpg',
    //合作客户30张图(尺寸:236*150)
    customers:[
      // 1.中粮
      httpUrl+'portal/static/partner/001.jpg',
      // 2.康师傅
      httpUrl+'portal/static/partner/006.jpg',
      // 3.sacmi
      httpUrl+'portal/static/partner/010.jpg',
      // 4.紫江企业
      httpUrl+'portal/static/partner/009.jpg',
      // 5.农夫山泉
      httpUrl+'portal/static/partner/014.jpg',
      // 6.信联智通
      httpUrl+'portal/static/partner/003.jpg',
			// 7.紫日包装
			httpUrl+'portal/static/partner/026.jpg',
			// 8.berry
			httpUrl+'portal/static/partner/021.jpg',
			// 9.益海嘉里
			httpUrl+'portal/static/partner/022.jpg',
			// 10.怡宝
			httpUrl+'portal/static/partner/011.jpg',
			// 11.广州华严
			httpUrl+'portal/static/partner/025.jpg',
      // 12.珠海中富
      httpUrl+'portal/static/partner/012.jpg',
			// 13.白云
			httpUrl+'portal/static/partner/023.jpg',
			// 14.乐惠
			httpUrl+'portal/static/partner/024.jpg',
			// 15.和晟塑料
			httpUrl+'portal/static/partner/020.jpg',
      // 16.今麦郎
      httpUrl+'portal/static/partner/015.jpg',
			// 17.伟塑
			httpUrl+'portal/static/partner/027.jpg',
			// 18.狮子头
			httpUrl+'portal/static/partner/028.jpg',
      // 19.银鹭
      httpUrl+'portal/static/partner/007.jpg',
			// 20.雀巢
			httpUrl+'portal/static/partner/018.jpg',
      // 21.可口可乐
      httpUrl+'portal/static/partner/004.jpg',
			// 22.百事
			httpUrl+'portal/static/partner/032.jpg',
      // 23.达利集团
      httpUrl+'portal/static/partner/013.jpg',
			// 24.万容
			httpUrl+'portal/static/partner/029.jpg',
      // 25.thc
      httpUrl+'portal/static/partner/002.jpg',
			// 26.汇源
			httpUrl+'portal/static/partner/016.jpg',
			// 27.恒大冰泉
			httpUrl+'portal/static/partner/030.jpg',
			// 28.统一企业
			httpUrl+'portal/static/partner/019.jpg',
      // 29.5100
      httpUrl+'portal/static/partner/008.jpg',
			// 30.健力宝
			httpUrl+'portal/static/partner/031.jpg',
      // 乐百氏
      // httpUrl+'portal/static/partner/005.jpg',
			// 蒙牛
			// httpUrl+'portal/static/partner/017.jpg',
    ],
    // 博仕机电二维码(尺寸300*300)
    wx:staticUrl+'tel/001.png',
    // 产品分类图片移动端(尺寸750*750)
    products:[
      staticUrl + 'fenlei/001.png',
      staticUrl + 'fenlei/002.jpg',
      staticUrl + 'fenlei/003.jpg',
      staticUrl + 'fenlei/004.jpg',
      staticUrl + 'fenlei/005.jpg',
      staticUrl + 'fenlei/006.png',
      staticUrl + 'fenlei/007.jpg'
    ],
    // 产品分类图片PC端(尺寸750*750)
    productsPC:[
      staticUrl + 'fenlei/001.png',
      staticUrl + 'fenlei/002.jpg',
      staticUrl + 'fenlei/003.jpg',
      staticUrl + 'fenlei/004.jpg',
      staticUrl + 'fenlei/005.jpg',
      staticUrl + 'fenlei/006.png',
      staticUrl + 'fenlei/007.jpg'
    ]
  },
  aboutBuchtech:{
    // 企业简介处头图(尺寸650*400)
    decrib:httpUrl+'portal/static/buchtech.jpg',
    // 企业历程处3张图片(尺寸90*90)
    historys:[
      staticUrl+'aboutBuchtech/1.png',
      staticUrl+'aboutBuchtech/2.png',
      staticUrl+'aboutBuchtech/3.png'
    ],
    // 企业荣誉资质图片(尺寸208*250)
    honor:[
      httpUrl + 'portal/static/certification/001.png?v=20200221',
      httpUrl + 'portal/static/certification/002.png?v=20200221',
      httpUrl + 'portal/static/certification/003.png?v=20200221',
      httpUrl + 'portal/static/certification/004.png?v=20200221',
      httpUrl + 'portal/static/certification/005.png?v=20200221',
      httpUrl + 'portal/static/certification/006.png?v=20200221',
      httpUrl + 'portal/static/certification/007.png?v=20200221',
      httpUrl + 'portal/static/certification/008.png?v=20200221',
      httpUrl + 'portal/static/certification/009.png?v=20200221'
    ],
		cultures:{
			en: staticUrl+'arrow/1.jpg',
			zh:staticUrl+'arrow/2.png'
		}
  },
	
  catalogBg:[
    staticUrl+'product_title_bg0.jpg',
    staticUrl+'product_title_bg1.jpg',
    staticUrl+'product_title_bg2.jpg',
    staticUrl+'product_title_bg3.jpg',
    staticUrl+'product_title_bg4.jpg',
    staticUrl+'product_title_bg5.jpg',
    staticUrl+'product_title_bg6.jpg'
  ]
}

export { resources }




//////////////////
// WEBPACK FOOTER
// ./static/resources/resources.js
// module id = UCj7
// module chunks = 8